<template>
  <div>
    <div class="QuotaManageCom" id="printQuotaManageCom" ref="printQuotaManageCom">
      <div class="Context">
        <div class="LOGO">
          <img src="@/assets/icon/login/login-bg-top.png" alt="">
        </div>
        <div class="rightTopText">
          {{ QuotaData.CusName }}
        </div>
        <div class="rightBottomText">
          Zylox-TonbridgeMedicalTechnologyCo.,Ltd
        </div>
        <div class="line">

        </div>
        <div class="TitleCenter">
          {{ QuotaData.Title }}
        </div>
        <div class="RevisionDate">
          <!-- <span style="text-decoration: underline;margin-left: 5px;margin-right: 5px;">1</span> -->
          修订时间：{{QuotaData.UpdateTime}}
        </div>
        <div class="company">
          {{ QuotaData.CusName }}（公章）:
        </div>
        <div class="Table">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th v-for="(item , index) of headerDataCompany" :key="index" :style="[{width: `${ item.columnwidth }px`}]">{{item.label}}</th>
            </tr>
            <tr v-for="(item , index) of QuotaData.YearQuota" :key="index">
              <td>{{ item.Quota }}</td>
              <td>{{ item.YearQuota }}</td>
            </tr>
          </table>
        </div>
        <div class="JDCG">
          季度采购指标：
        </div>
        <div class="Table">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th v-for="(item , index) of headerDataJDCG" :key="index" :style="[{width: `${ item.columnwidth }px`}]">{{item.label}}</th>
            </tr>
            <tr v-for="(item , index) of QuotaData.QuarterQuota" :key="index">
              <td>{{ item.Quota }}</td>
              <td>{{ item.FirstQuarterQuota }}</td>
              <td>{{ item.SecondQuarterQuota }}</td>
              <td>{{ item.ThirdQuarterQuota }}</td>
              <td>{{ item.ForthQuarterQuota }}</td>
            </tr>
          </table>
        </div>
        <div class="monthQuota">
          月采购指标分配：
        </div>
        <div class="Table">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <th v-for="(item , index) of headerDataMonth" :key="index" :style="[{width: `${ item.columnwidth }px`}]">{{item.label}}</th>
            </tr>
            <tr v-for="(item , index) of QuotaData.MonthQuota" :key="index">
              <td>{{ item.Quota }}</td>
              <td>{{ item.JanQuota }}</td>
              <td>{{ item.FebQuota }}</td>
              <td>{{ item.MarQuota }}</td>
              <td>{{ item.AprQuota }}</td>
              <td>{{ item.MayQuota }}</td>
              <td>{{ item.JunQuota }}</td>
              <td>{{ item.JulQuota }}</td>
              <td>{{ item.AugQuota }}</td>
              <td>{{ item.SepQuota }}</td>
              <td>{{ item.OctQuota }}</td>
              <td>{{ item.NovQuota }}</td>
              <td>{{ item.DecQuota }}</td>
            </tr>
          </table>
        </div>
        <div class="QuotaManageFoot">
          <div class="Top">
            Building No. , 18 Keji Avenue, Wenyixi Road, Future Science & Technology City, Hangzhou, 311121, China
          </div>
          <div class="Centers">
            杭州市文一西路未来科技城科技大道18号1幢
          </div>
          <div class="Bottom">
            TEL：(+86) 571 8861 0082 FAX：(+86) 571 8861 0608 website:www.zyloxmedical.com
          </div>
        </div>
      </div>
    </div>
    <div class="download">
      <Btn btnType="btn" backgroundColor="#FFFFFF" width="64px" height="32px" title="下载" color="#666666" border="1px solid #E5E5E5" @btnclick="download(QuotaData)"></Btn>
    </div>
    <div class="Print">
      <Btn btnType="btn" backgroundColor="#E71D43" width="64px" height="32px" title="打印" color="#FFFFFF" border="1px solid #E5E5E5" @btnclick="Print(QuotaData)"></Btn>
    </div>
  </div>
</template>
<script> 
import headerDataCompanyFrom from './headerData/headerDataCompany'
import headerDataJDCG from './headerData/headerDataJDCG'
import headerDataMonth from './headerData/headerDataMonth'
import Btn from '../../../../../../../components/common-btn.vue'
import printAll from '../../../../../../../common/Print'
export default {
  components: { Btn },
  props: {
    QuotaData: {
      type: Object
    }
  },
  data() {
    return {
      headerDataCompany: [],
      headerDataJDCG: [],
      headerDataMonth: [],
      printObj: {
        id: "printQuotaManageCom", //打印页面的id
        popTitle: '', //打印的标题
        preview: false,
        //打印成功后的回调
        endCallback() {

        },
        beforeOpenCallback(vue) {
          console.log('打开之前')
        },
        closeCallback(vue) {
          console.log('关闭了打印工具', this.btn, vue)
        }
      }
    }
  },
  created() { },
  mounted() {
    this.headerDataCompany = JSON.parse(JSON.stringify(headerDataCompanyFrom))
    this.headerDataJDCG = JSON.parse(JSON.stringify(headerDataJDCG))
    this.headerDataMonth = JSON.parse(JSON.stringify(headerDataMonth))
  },
  activated() { },
  updated() { },
  methods: {
    download(QuotaData) {
      this.$emit('download',QuotaData)
    },
    Print(QuotaData) {
      this.$emit('Print',QuotaData)
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.Print {
  display: inline-block;
  margin-left: -10px;
}
.download {
  display: inline-block;
  margin-left: 950px;
  margin-top: 20px;
}
.QuotaManageCom {
  width: 100%;
  // height: 100%;
  position: relative;
  // border: 1px solid red;
   size: A4;
  .Context {
    width: 1000px;
    // height: 760px;
    background: #ffffff;
    box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.10000000149011612);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    margin: 0 auto;
    padding: 24px;
    position: relative;

    .line {
      width: 100%;
      height: 1px;
      background-color: #333333;
      margin-top: 10px;
    }
  }

  .LOGO {
    img {
      width: 120.25px;
      height: 52px;
    }
  }

  .rightTopText {
    font-size: 16px;
    font-weight: normal;
    color: #333333;
    float: right;
    margin-top: -55px;
  }

  .rightBottomText {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    float: right;
    margin-top: -20px;
  }

  .TitleCenter {
    font-size: 24px;
    font-weight: normal;
    color: #333333;
    position: relative;
    left: 313px;
    // margin-top: 40px;
    margin: 30px auto auto 40px;
  }

  .RevisionDate {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 20px;
  }

  .company {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 16px;
  }
  .JDCG {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 16px;
  }
  .monthQuota {
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    margin-top: 16px;
  }

  .QuotaManageFoot {
    width: 752px;
    height: 60px;
    font-size: 10px;
    font-weight: normal;
    // border: 1px solid red;
    color: #333333;
    margin: 48px auto 0 auto;
    // position:absolute;
    //   bottom: 0;
    //   left: 8%;

    .Top {
      text-align: center;
    }

    .Centers {
      text-align: center;
    }
    .Bottom {
      text-align: center;
    }
  }
}
.Table {
  margin-top: 8px;
}

table {
  border: 1px solid #eeeeee;
  border-collapse: collapse;
  tr {
    td,
    th {
      //   width: 240px;
      height: 32px;
      background: #f9f9f9;
      opacity: 1;
      text-align: center;
      font-size: 14px;
      font-weight: normal;
      color: #333333;
      border: 1px solid #eeeeee;
    }
  }
}
</style>